/*
 * RIDECLOUD FOOTER
 * Style: Original RideCloud — deep purple (#2e004f) background, white text
 * Logo: icon + wordmark (white invert), nav links, legal links, copyright
 */

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ backgroundColor: "#2e004f" }}>
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img
                src="https://d2xsxph8kpxj0f.cloudfront.net/310519663326861339/FdaTdcVYATQM4PxPcH7X9e/ridecloud-master-logo-secondary-white_4b722d82.png"
                alt="RideCloud"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: "rgba(255,255,255,0.55)" }}>
              Flexible, all-inclusive vehicle subscriptions for people and businesses who don't want long-term debt — built in South Africa.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: "rgba(255,255,255,0.4)" }}>
              Navigate
            </div>
            <div className="space-y-2">
              {[
                { label: "Vehicles", href: "#vehicles" },
                { label: "Why Subscribe?", href: "#why" },
                { label: "How It Works", href: "#how-it-works" },
                { label: "FAQ", href: "#faq" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href)}
                  className="block text-sm transition-colors text-left"
                  style={{ color: "rgba(255,255,255,0.55)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#e6531e"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; }}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Legal & Contact */}
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: "rgba(255,255,255,0.4)" }}>
              Legal & Contact
            </div>
            <div className="space-y-2">
              {[
                { label: "End User License Agreement", href: "#" },
                { label: "PAIA Manual", href: "#" },
                { label: "Privacy Policy", href: "#" },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="block text-sm transition-colors"
                  style={{ color: "rgba(255,255,255,0.55)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#e6531e"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; }}
                >
                  {link.label}
                </a>
              ))}
              <div className="pt-2 space-y-1">
                <a href="tel:+27836565677" className="block text-sm transition-colors" style={{ color: "rgba(255,255,255,0.55)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#e6531e"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; }}>
                  +27 83 656 5677
                </a>
                <a href="mailto:sales@ridecloud.co.za" className="block text-sm transition-colors" style={{ color: "rgba(255,255,255,0.55)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#e6531e"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; }}>
                  sales@ridecloud.co.za
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}
        >
          <p className="text-xs" style={{ color: "rgba(255,255,255,0.35)" }}>
            © 2026 RideCloud. All rights reserved. Registered in South Africa.
          </p>
          <div className="flex gap-4">
            {["LinkedIn", "Twitter", "Facebook", "Instagram"].map((s) => (
              <a
                key={s}
                href="#"
                className="text-xs transition-colors"
                style={{ color: "rgba(255,255,255,0.35)" }}
                onMouseEnter={(e) => { e.currentTarget.style.color = "#e6531e"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.35)"; }}
              >
                {s}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
